module.exports = __webpack_public_path__ + "img/m.a2368d67.png";